import type { MessageActionInvocationStatus } from '@atlassian/conversation-assistant-service-api/types/message-actions';
import {
	type CommandConstructor,
	type CommandProperties,
	type SerializableValue,
} from '@atlassian/rovo-content-bridge-api/command';
import { createCommand } from '@atlassian/rovo-content-bridge-api/command-creator';

export type JiraCreateItemsData = {
	projectIdOrKey: string;
	issueTypeId: string;
	summary: string;
	fields: Record<string, any>;
};

export type JiraCreateItemsAction = {
	/**
	 * The unique key identifier for the items creation request.
	 */
	key: string;
	/**
	 * The unique identifier for the action.
	 */
	actionId?: string;
	/**
	 * The unique identifier for the invocation.
	 */
	invocationId: string;
	/**
	 * The current status of the creation process.
	 */
	status?: MessageActionInvocationStatus;
	/**
	 * The data payload containing the content for the new item.
	 */
	data: JiraCreateItemsData;
};

/**
 * Properties for the Jira items creation command.
 *
 * @extends CommandProperties
 */
export interface JiraCreateItemsCommandProperties extends CommandProperties {
	/**
	 * The actions containing the data to create the new items.
	 */
	actions: JiraCreateItemsAction[];
}

/**
 * A command sent by a bridge API client to create a new Jira items.
 *
 * @summary {@link CommandProperties.senderId} is requesting {@link CommandProperties.receiverId} to create a Jira items with the specified content.
 */
export const JiraCreateItemsCommand: CommandConstructor<
	JiraCreateItemsCommandProperties,
	SerializableValue
> = createCommand<JiraCreateItemsCommandProperties>('jira-create-items-command');
